import Search from 'lib/Search';
import { InputValue } from 'components/common/types/Input.types';
import { TextFilterKey } from './AdvancedFilters.types';

const TEXT_FILTER_HINT = 'Type keyword to search and press Enter or click outside';

interface TextFilterPanelProps {
  filterKey: TextFilterKey;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}

export const TextFilterPanel = ({
  filterKey,
  value,
  placeholder,
  onChange,
}: TextFilterPanelProps): React.ReactElement => {
  const handleChange = (inputValue: InputValue): void => {
    onChange(String(inputValue ?? ''));
  };

  return (
    <div className="min-w-62.5 bg-white border border-neutral-200 rounded-md overflow-hidden shadow-dropdownMenu">
      <div className="px-3 pt-2">
        <Search
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          dataTestId={`search-${filterKey}-filter`}
        />
        <p className="text-center text-neutral-600 px-5 py-2.5 body-base">{TEXT_FILTER_HINT}</p>
      </div>
    </div>
  );
};
